import {
  graphql
} from 'react-relay'






const query = graphql`
    query getAllQuotationSupplierQuery($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllQuotationSupplier (pagination: $pagination, sorts: $sorts, where: $where){
            count,
            items{
                  id
                  title
                  description
                  date
                  num
                  tax
                  discountType
                  discountValue
                  total
                  totalTTC
                  currencyId
                  supplierId
                  createdAt
                  updatedAt
                  deletedAt
                  supplier {id, name}
                }
      }
    }
  `

export default query;